import { chunk, last } from 'lodash';
const initialStateStatic = {
	/**
	 * Xác định xem nó đã đăng nhập hay chưa
	 */
    // isLogin: false,
    onSound: true,
    maxWin: false,
    clientInfo: {},
    listChat: [],
    infoStaff: {}
};

const routerReducersStatic = (state = initialStateStatic, { type, payload } = {}) => {
    let states = state;
    switch (type) {
        case 'ON_SOUND':
            states = {
                ...state,
                onSound: payload
            };
            break;
        case 'MAX_WIN':
            states = {
                ...state,
                maxWin: payload
            };
            break;
        case 'CLIENT_INFO':
            states = {
                ...state,
                clientInfo: payload
            };
            break;
        case 'LIST_CHAT':
            states = {
                ...state,
                listChat: payload
            };
            break;
        case 'ADD_MSG_LIST_CHAT':
            states = {
                ...state,
                listChat: last(chunk([...state.listChat, payload], 300))
            };
            break;
        case 'REMOVE_ALL':
            states = {
                ...state,
                listChat: [],
                clientInfo: payload,
                maxWin: false,
                infoStaff: {}
            };
            break;
        case 'INFO_STAFF':
            states = {
                ...state,
                infoStaff: payload
            };
            break;
        default:
            states = state;
            break;
    }
    return states;
};
export default routerReducersStatic;


// WEBPACK FOOTER //
// ./src/redux/routerReducersStatic.js